import React, { Component } from 'react';

//componentes
import VerPagos from './verPagos'

class Index extends Component {

    render(){
        return(
            <div>
                <VerPagos />
            </div>
        );
    }

}
export default Index;